import useReveal from "../hooks/useReveal";

const METRICS = [
  { k: "100%", l: "Renewable Energy", s: "Zero-carbon by design" },
  { k: "0", l: "Carbon Footprint", s: "Net-zero supercomputing" },
  { k: "10K+", l: "GPU Capacity Target", s: "Exascale-class" },
  { k: "AU", l: "Data Sovereignty", s: "Insulated from foreign jurisdictions" },
];

export default function Metrics() {
  const ref = useReveal();
  return (
    <section
      ref={ref}
      id="metrics"
      data-testid="metrics-section"
      className="relative py-28 md:py-40 overflow-hidden"
      style={{ background: "var(--bg-deep)" }}
    >
      <div
        className="absolute inset-0 bg-cover bg-center opacity-20 dark:opacity-30"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/17323801/pexels-photo-17323801.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
          filter: "grayscale(100%) contrast(1.1)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to bottom, var(--hero-fade-80) 0%, var(--hero-fade) 60%, var(--bg-deep) 100%)",
        }}
      />
      <div className="absolute inset-0 grid-backdrop opacity-50" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="reveal mb-16 max-w-3xl">
          <div className="eyebrow mb-4">— 02 / Impact</div>
          <h2 className="font-display text-3xl md:text-5xl text-[var(--text)] leading-[1.05] tracking-tight">
            The numbers behind a{" "}
            <span className="text-[var(--color-primary)] dark:text-[var(--color-lime)]">net-zero</span> compute future.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
          {METRICS.map((m, i) => (
            <div
              key={m.l}
              data-testid={`metric-${i}`}
              className="reveal border-t border-[var(--border-strong)] pt-6"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="font-display text-[var(--text)] text-5xl md:text-7xl lg:text-[88px] leading-none tracking-[-0.03em]">
                {m.k}
              </div>
              <div className="mt-5 font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--color-teal)]">
                {m.l}
              </div>
              <div className="mt-2 text-[var(--text-55)] text-sm">{m.s}</div>
            </div>
          ))}
        </div>

        {/* moving marquee */}
        <div className="mt-24 overflow-hidden border-y border-[var(--border-subtle)] py-6 reveal">
          <div className="marquee-track flex gap-16 whitespace-nowrap will-change-transform">
            {Array.from({ length: 2 }).map((_, idx) => (
              <div key={idx} className="flex gap-16">
                {[
                  "AI-EXASCALE",
                  "ZERO-CARBON",
                  "SOVEREIGN-CLOUD",
                  "INDO-PACIFIC",
                  "RENEWABLE-GRID",
                  "NATIONAL-RESILIENCE",
                  "GPU-FABRIC",
                  "REGIONAL-COLLAB",
                ].map((w) => (
                  <span
                    key={w + idx}
                    className="font-display text-3xl md:text-5xl text-[var(--text-15)] tracking-tight"
                  >
                    {w}{" "}
                    <span className="text-[var(--color-yellow-deep)]/40 dark:text-[var(--color-yellow)]/40">/</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
